// @flow

import React, { Component } from 'react';
import StyleSheet from 'stilr';

const common = {
  padding: 15,
  border: '1px solid transparant',
  borderRadius: 4,
  margin: '15px 0'
};

const styles = StyleSheet.create({
  danger: {
    ...common,
    color: '#a94442',
    background: '#f2dede',
    borderColor: '#ebccd1'
  },
  success: {
    ...common,
    color: '#3c763d',
    background: '#dff0d8',
    bordercolor: '#d6e9c6'
  }
});

class Alert extends Component {
  render() {
    return (
      <div
        className={
          this.props.type === 'success'
            ? `${styles.success} success`
            : `${styles.danger} danger`
        }
      >
        {this.props.text}
      </div>
    );
  }
}

export default Alert;
